let temp = lang => `
<div id="upload-list" class="upload-list ${lang.isApprove ? 'upload-list-approve' : ''}"  style="display: none">
<div id="mask-upload" class="lui-mask-upload" style="display:none;"></div>
  <div class="upload-list-header">
    <div class="upload-list-header-title" style="padding-left: 17px;">${lang.upload_list}</div>
    <div class="upload-list-header-tool">
      <i class="icon-upload ico-upload-max-normal"></i>
      <i class="icon-upload ico-upload-min-normal"></i>
      <i class="icon-upload ico-upload-close-normal"></i>
    </div>
  </div>
  <div class="upload-list-body" style="background-color: #fff;">
    <div id="uploadlistScroll">
    <table style="width: 100%" cellpadding="0" cellspacing="0" border="0">
        <thead>
          <tr>
            <td colspan="5" style="padding: 0px;">
              <div style="width: 30%;float: left;padding-left:24px;color:#818DA3;text-align: left;">${lang.name}</div>
              <div style="width: 25%;float: left;padding: 0px 10px;color:#818DA3;text-align: left;">${lang.progress}</div>
              <div style="width: 10%;float: left;padding: 0px 10px;color:#818DA3;text-align: left;">${lang.size}</div>
              <div style="width: 12%;float: left;padding: 0px 10px;color:#818DA3;text-align: left;">${lang.time}</div>
              <div style="width: 8%;float: left;color:#818DA3;text-align: center;">
                <span class="cancel-all">${lang.cancel}</span>
              </div>
            </td>
          </tr>
        </thead>
        <tbody id="body-list" is="transition-group" name="list">
          
        </tbody>
      </table>
      </div>
      <div class="upload-list-extend"></div>
  </div>
</div>
`
// <tr>
// <td style="width: 30%;">${lang.name}</td>
// <td style="width: 15%;">${lang.progress}</td>
// <td style="width: 15%;">${lang.size}</td>
// <td style="width: 15%;">${lang.time}</td>
// <td style="width: 25%;">
// <span class="cancel-all">${lang.cancel}</span>
// </td>
// </tr>
export default temp



// WEBPACK FOOTER //
// ./src/components/upload/upload_list/upload-temp.js